import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row g-3 g-md-4" }
const _hoisted_2 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_3 = { class: "d-block text-capitalize" }
const _hoisted_4 = { class: "fs-20 mb-0 mt-1" }
const _hoisted_5 = {
  key: 0,
  class: "bottom-0 fw-normal text-body fs-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card border-0 rounded-3 bg-white p-25 bg-img mb-4",
    style: _normalizeStyle({ 'background-image': `url(${_ctx.bgImage})` }),
    role: "status",
    "aria-live": "polite"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "col-xxl-3 col-sm-6"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatKey(key)), 1),
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(stat.value) + " ", 1),
              (stat.date)
                ? (_openBlock(), _createElementBlock("sub", _hoisted_5, " (" + _toDisplayString(stat.date) + ") ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ], 4))
}